module.exports = __webpack_public_path__ + "static/media/5.eb6d27fb.svg";